import React, { useContext, useEffect, useMemo, useState } from "react";
import { NavItem, Nav } from "reactstrap";
import classNames from "classnames";
import { Link } from "react-router-dom";
import {
  FaTachometerAlt,
  FaUsers,
  FaUserTie,
  FaVoteYea,
  FaCogs,
  FaListAlt,
} from "react-icons/fa";
import logo from "../../../image/karanLogo.png";
import "./Sidebar.css";
import { FEATURES, hasAccess } from "../../helper";
import SubMenu from "./SubMenu";
import { getStorage } from "../../helper/storage";
import banner from "../../../image/banner.jpg";
import UserContext from "../../helper/UserContext";

// Single list of every sidebar destination. Visibility for a given user is
// decided by hasAccess(user_type, feature) against the central roles config
// (helper/roles.config.js) instead of one hardcoded array per role.
//
// Dropdown parent modules: an item with a `Child` array renders as an
// expand/collapse group (see the render branch below) instead of a direct
// link, and each entry in `Child` is gated individually by its own
// `feature` - visibleMenuItems below filters at both levels, and drops a
// parent entirely if none of its children are visible to the current role.
const MENU_ITEMS = [
  {
    name: "Dashboard",
    key: "Dashboard",
    path: "/dashboard",
    logo: <FaTachometerAlt />,
    feature: FEATURES.DASHBOARD,
  },
  {
    name: "Voter Management",
    key: "voterManagement",
    path: "/voter-management",
    logo: <FaVoteYea />,
    Child: [
      { name: "Dashboard", path: "/voter-management/dashboard", feature: FEATURES.DASHBOARD },
      { name: "Voter Search", path: "/voter-management/search", feature: FEATURES.VOTER_SEARCH },
      { name: "Age Wise Search", path: "/voter-management/age-search", feature: FEATURES.AGE_SEARCH },
      { name: "Alphabetical Search", path: "/voter-management/alphabetical-search", feature: FEATURES.ALPHABETICAL_SEARCH },
      { name: "Delete Voter", path: "/voter-management/delete", feature: FEATURES.DELETE_VOTER },
      { name: "Upload", path: "/voter-management/upload", feature: FEATURES.UPLOAD_EXCEL },
      { name: "Add Voter", path: "/voter-management/add", feature: FEATURES.ADD_VOTER },
    ],
  },
  {
    name: "Application Management",
    key: "applicationManagement",
    path: "/application-management",
    logo: <FaCogs />,
    Child: [
      { name: "App List", path: "/application-management/list", feature: FEATURES.SYSTEM_SETTINGS },
      { name: "Change App Name", path: "/application-management/change-name", feature: FEATURES.SYSTEM_SETTINGS },
      { name: "Add App", path: "/application-management/add", feature: FEATURES.SYSTEM_SETTINGS },
    ],
  },
  {
    name: "User Management",
    key: "userManagement",
    path: "/user-management",
    logo: <FaUsers />,
    Child: [
      { name: "User List", path: "/user-management", feature: FEATURES.USER_MANAGEMENT },
      { name: "Add User", path: "/user-management/add", feature: FEATURES.USER_MANAGEMENT },
    ],
  },
  {
    name: "Cast Management",
    key: "castManagement",
    path: "/cast-management",
    logo: <FaListAlt />,
    Child: [
      { name: "Cast And Profession List", path: "/cast-management", feature: FEATURES.CAST_PROFESSION },
      { name: "Upload", path: "/cast-management/upload", feature: FEATURES.CAST_PROFESSION },
      { name: "Add Cast And Profession", path: "/cast-management/add", feature: FEATURES.CAST_PROFESSION },
    ],
  },
  {
    name: "Booth Agent Management",
    key: "boothAgentManagement",
    path: "/booth-agent-management",
    logo: <FaUserTie />,
    Child: [
      { name: "Booth Agent List", path: "/booth-agent-management", feature: FEATURES.BLA_BLE },
      { name: "Add Booth Agent", path: "/booth-agent-management/add", feature: FEATURES.BLA_BLE },
    ],
  },
];

// const LANGUAGE_STORAGE_KEY = "electioneasy_voter_form_language";
// const languageOptions = [
//   { value: "both", label: "Both" },
//   { value: "english", label: "English" },
//   { value: "hindi", label: "Hindi" },
// ];

// const getStoredLanguage = () => {
//   const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
//   return languageOptions.some((item) => item.value === stored)
//     ? stored
//     : "both";
// };
// REPLACE WITH THIS:
const LANGUAGE_STORAGE_KEY = "electioneasy_voter_form_language";

const ALL_LANGUAGE_OPTIONS = [
  { value: "both", label: "Both" },
  { value: "english", label: "English" },
  { value: "hindi", label: "Hindi" },
];

// No static fallback: an empty/missing "app_available_languages" (eg. the
// API returned language_supported: null) means no languages to offer, not
// "show all three" - the caller is responsible for hiding the switcher when
// this comes back empty.
const getAvailableLanguages = () => {
  try {
    const stored = localStorage.getItem("app_available_languages");
    if (stored) {
      const parsed = JSON.parse(stored);
      return ALL_LANGUAGE_OPTIONS.filter((opt) => parsed.includes(opt.value));
    }
  } catch {
    // ignore parse errors
  }
  return [];
};

const getStoredLanguage = () => {
  const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
  const available = getAvailableLanguages();
  return available.some((item) => item.value === stored)
    ? stored
    : available[0]?.value ?? "both";
};
const Sidebar = ({ isOpen, toggle }) => {
  const [settingToggle, setSettingToggle] = useState("");
  const [newPermission, setNewPermission] = useState();
  // const [voterLanguage, setVoterLanguage] = useState(getStoredLanguage);
  // REPLACE WITH THIS (add languageOptions state + voterLanguage):
const [languageOptions, setLanguageOptions] = useState(getAvailableLanguages);
console.log("45",languageOptions);

const [voterLanguage, setVoterLanguage] = useState(getStoredLanguage);
  const userLogin = getStorage("logged-in");
  const AppName = getStorage("app_name");
  const { user, setUser } = useContext(UserContext);

  const handleLanguageChange = (language) => {
    setVoterLanguage(language);
    localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    window.dispatchEvent(
      new CustomEvent("voterLanguageChange", { detail: language }),
    );
  };

  useEffect(() => {
    setSettingToggle(window.location.pathname);
  }, [window.location.pathname]);
useEffect(() => {
  const handleUpdate = () => {
    setLanguageOptions(getAvailableLanguages());
    setVoterLanguage(getStoredLanguage());
  };
  window.addEventListener("storage", handleUpdate);
  window.addEventListener("appLanguagesUpdated", handleUpdate);
  handleUpdate(); // run once on mount

  return () => {
    window.removeEventListener("storage", handleUpdate);
    window.removeEventListener("appLanguagesUpdated", handleUpdate);
  };
}, []);
  const visibleMenuItems = useMemo(
    () =>
      MENU_ITEMS.map((item) =>
        item.Child
          ? {
              ...item,
              Child: item.Child.filter((child) =>
                hasAccess(userLogin?.user_type, child.feature),
              ),
            }
          : item,
      ).filter((item) =>
        item.Child
          ? item.Child.length > 0
          : hasAccess(userLogin?.user_type, item.feature),
      ),
    [userLogin?.user_type],
  );

  console.log(user);

  return (
    <div className={classNames("sidebar", { "is-open": isOpen })}>
      <div className="sidebar-header">
        <span color="info" onClick={toggle} style={{ color: "#fff" }}>
          &times;
        </span>
        <div className="sideBarLogo_div">{user.appName}</div>
      </div>
      <div className="side-menu">
        <Nav vertical className="list-unstyled pb-3 pt-2">
          {visibleMenuItems?.map((item, i) => {
            return (
              <>
                <NavItem key={item.path}>
                  {item?.Child?.length > 0 ? (
                    <button
                      onClick={() =>
                        setSettingToggle(
                          item?.Child?.some(
                            (child) => child?.path === settingToggle,
                          ) || settingToggle === item.name
                            ? ""
                            : item.name,
                        )
                      }
                      className={
                        (item?.Child?.some(
                          (child) => child?.path === settingToggle,
                        ) || settingToggle === item.name
                          ? "active "
                          : "") + " nav-link"
                      }
                      key={i}
                      to={item.path}
                    >
                      <span className="sidebar_logo">{item.logo}</span>
                      <span>{item.name}</span>
                    </button>
                  ) : (
                    <Link
                      className={
                        (settingToggle === item.path ? "active " : "") +
                        " nav-link"
                      }
                      key={i}
                      to={item.path}
                    >
                      <span className="sidebar_logo">{item.logo}</span>
                      <span>{item.name}</span>
                    </Link>
                  )}
                  {(item?.Child?.some(
                    (child) => child?.path === settingToggle,
                  ) ||
                    settingToggle === item.name) && (
                    <div className="anvSubmenu">
                      {item?.Child && (
                        <>
                          <Nav vertical className="list-unstyled pb-3 pt-2">
                            {item?.Child?.map((item, i) => (
                              <NavItem key={item.path}>
                                <Link
                                  className={
                                    (settingToggle === item.path
                                      ? "active "
                                      : "") + " nav-link"
                                  }
                                  key={i}
                                  to={item.path}
                                >
                                  <span>{item.name}</span>
                                </Link>
                              </NavItem>
                            ))}
                          </Nav>
                        </>
                      )}
                    </div>
                  )}
                </NavItem>
              </>
            );
          })}
        </Nav>
      </div>
      {languageOptions.length > 0 && (
        <div className="sidebar-language-selector">
          <div className="sidebar-language-title">Voter Language</div>
          <div className="sidebar-language-options">
            {languageOptions.map((option) => (
              <button
                key={option.value}
                type="button"
                className={
                  voterLanguage === option.value
                    ? "sidebar-language-btn active"
                    : "sidebar-language-btn"
                }
                onClick={() => handleLanguageChange(option.value)}
              >
                {option.label}
              </button>
            ))}
          </div>
        </div>
      )}
{user?.appDetails?.banner_image && (
  <div className="banner_div">
    <img
      src={user.appDetails.banner_image}
      alt="App banner"
      onError={({ currentTarget }) => {
        currentTarget.style.display = "none";
      }}
    />
  </div>
)}
    </div>
  );
};

export default Sidebar;
